import React, { createRef } from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';

import DocsNav from './DocsNav';
import DocProblems from './DocProblems';
import AdminLayout from '../../../layouts/AdminLayout';

class DocumentParser extends React.Component {
  constructor() {
    super();
    this.state = {
      fileList: [],
      activeFile: null
    };

    this.mainContainerRef = createRef();
    this.handleWindowResize = this.handleWindowResize.bind(this);
    this.handleFilesChange = this.handleFilesChange.bind(this);
    this.handleActiveFileChange = this.handleActiveFileChange.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
    this.forceUpdate(); // refreshes main container style
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  get mainContainerStyle() {
    try {
      const mainContainer = this.mainContainerRef.current;
      if (mainContainer) {
        const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        return {
          height: `${windowHeight - mainContainer.offsetTop}px`
        };
      }
      return {
        height: '100vh'
      };
    }
    catch (e) {
      return {
        height: '100vh'
      };
    }
  }

  handleWindowResize() {
    this.forceUpdate();
  }

  handleFilesChange(files) {
    this.setState({fileList: files});
  }

  handleActiveFileChange(file) {
    this.setState({activeFile: file});
  }

  render() {
    const {
      fileList,
      activeFile
    } = this.state;
    return (
      <AdminLayout maxWidth={false}>
        <div className="mb-3 mt-3">
          <Card>
            <CardContent>
              <Typography variant="h5" className="mb-3"s>Parse Document</Typography>
              <Typography>A utility to quickly parse exam-checker specifications from exercise files (.docx supported).</Typography>
            </CardContent>
          </Card>
        </div>

        <div
          ref={this.mainContainerRef}
          style={this.mainContainerStyle}
          className="d-flex">

          <DocsNav
            files={fileList}
            onFilesChange={this.handleFilesChange}
            activeFile={activeFile}
            onActiveFileChange={this.handleActiveFileChange}
          />

          <DocProblems
            file={activeFile}
          />
        </div>

      </AdminLayout>
    );
  }
}

export default DocumentParser;
